import type { EntityDetailMetadata } from '@zag/ui';

export const WEBHOOK_DETAIL_METADATA = [
  {
    entity: 'webhook',
    route: '/settings/webhooks/:id',
    titleKey: 'webhooks.title',
    sections: [
      { id: 'configuration', titleKey: 'webhooks.sections.configuration' },
      { id: 'custom-headers', titleKey: 'webhooks.sections.customHeaders' },
      {
        id: 'deliveries',
        titleKey: 'webhooks.deliveries.title',
        visibleWhen: { mode: 'all', permissions: ['webhooks:deliveries:read'] },
        requiresEntityId: true,
      },
    ],
    actions: [
      { id: 'save', labelKey: 'common.save', visibleWhen: { mode: 'all', permissions: ['webhooks:manage'] }, intent: 'mutation' },
      {
        id: 'test',
        labelKey: 'webhooks.actions.test',
        visibleWhen: { mode: 'all', permissions: ['webhooks:manage'] },
        requiresEntityId: true,
        intent: 'mutation',
      },
      {
        id: 'delete',
        labelKey: 'webhooks.actions.delete',
        visibleWhen: { mode: 'all', permissions: ['webhooks:manage'] },
        requiresEntityId: true,
        intent: 'mutation',
      },
    ],
  },
] satisfies readonly EntityDetailMetadata[];
